module.exports = __webpack_public_path__ + "static/media/books.65671720.svg";